import { NgModule, Type } from '@angular/core';
import { Routes, RouterModule, Resolve, Route } from '@angular/router';

//NOVO
//import { GuidelinesComponent } from './guidelines/guidelines.component';

//Guidelines Pages
//import { ColorsComponent } from './guidelines/pages/design/colors/colors.component';
//import { TypographyComponent } from './guidelines/pages/design/typography/typography.component';
//import { IconsComponent } from './guidelines/pages/design/icons/icons.component';
//import { CardComponent } from './guidelines/pages/structure/card/card.component';
//import { SearchboxComponent } from './guidelines/pages/structure/searchbox/searchbox.component';
//import { TextfieldComponent } from './guidelines/pages/components/textfield/textfield.component';
//import { SelectComponent } from './guidelines/pages/components/select/select.component';
//import { CheckboxComponent } from './guidelines/pages/components/checkbox/checkbox.component';
//import { ButtonsComponent } from './guidelines/pages/components/buttons/buttons.component';
//import { ToastmessagesComponent } from './guidelines/pages/components/toastmessages/toastmessages.component';
//import { TableComponent } from './guidelines/pages/components/table/table.component';
//import { DatepickerComponent } from './guidelines/pages/components/datepicker/datepicker.component';
//import { ToogleButtonComponent } from './guidelines/pages/components/toogle-button/toogle-button.component';
//import { CardShadowComponent } from './guidelines/pages/structure/card-shadow/card-shadow.component';
//import { ModalComponent } from './guidelines/pages/components/modal/modal.component';
//import { TooltipComponent } from './guidelines/pages/components/tooltip/tooltip.component';
//import { TimelineComponent } from './guidelines/pages/components/timeline/timeline.component';
//import { FileinputComponent } from './guidelines/pages/components/fileinput/fileinput.component';
//import { SidebarComponent } from './guidelines/pages/structure/sidebar/sidebar.component';
//import { SpinnerComponent } from './guidelines/pages/components/spinner/spinner.component';


import { ShellComponent } from './shell/shell.component';

import { StepComponent } from './workflows/step.component';
import { WorkflowComponent } from './workflows/workflow.component';
import { WorkflowSearchComponent } from './workflow-search/workflow-search.component';
import { WorkflowInstanceCreatorComponent } from './workflow-instance-creator/workflow-instance-creator.component';
import { CommonDataResolver } from './_infrastructure/CommonData/CommonDataResolver';
import { SecurityService } from './_infrastructure/Security/SecurityService';
import { SubscriberInformationResolver } from './_infrastructure/SubscriberInfo/SubscriberInformationResolver';
import { SubmissionLandingPageComponent } from './SubmissionLandingPage/submission-landing-page.component';
import { ExSubsConfirmSubmissionComponent } from './SubmissionLandingPage/exsub-confirm-submission.component';


import { InstanceBrowserComponent } from './instance-browser/instance-browser.component';
import { ConfirmSubmissionComponent } from './SubmissionLandingPage/confirm-submission.component';

// PIT40802 \\
import { ValidatePGPOnlineComponent } from './validate-pgp-online.component';
import { WorkfGuard } from './_infrastructure/GuardRouting/workflow.guard';
// PIT40802 \\

import { WorkflowInstanceCreatorComponentPM } from './workflow-instance-creator-pm/workflow-instance-creator-pm.component';
import { WorkflowComponentNew } from './workflows/workflow-new.component';
import { StepComponentNew } from './workflows/step-new.component';
function addResolverToRouteHierarchy<T extends Type<Resolve<unknown>>>(route: Route, resolver: T, name: string): Route {
  if (route.resolve === null || route.resolve === undefined) {
    route.resolve = {};
  }
  route.resolve[name] = resolver;

  if (route.children !== null && route.children !== undefined)
    route.children.forEach(child => addResolverToRouteHierarchy(child, resolver, name))

  return route;
}

const addGlobalResolver = <T extends Type<Resolve<unknown>>>(routePaths: Routes, resolver: T, name: string): Routes => {
  return routePaths.map(route => {
    return addResolverToRouteHierarchy(route, resolver, name);
  });
};


const routes: Routes = [
  { path: '', redirectTo: '/workflowSearch', pathMatch: 'full' },
  //{ path: 'guidelines', component: GuidelinesComponent },
  //{
  //  path: 'guidelines',
  //  component: GuidelinesComponent,
  //  children: [
  //    { path: 'colors', component: ColorsComponent },
  //    { path: 'typography', component: TypographyComponent },
  //    { path: 'icons', component: IconsComponent },
  //    { path: 'card', component: CardComponent },
  //    { path: 'searchbox', component: SearchboxComponent },
  //    { path: 'textfield', component: TextfieldComponent },
  //    { path: 'select', component: SelectComponent },
  //    { path: 'checkbox', component: CheckboxComponent },
  //    { path: 'buttons', component: ButtonsComponent },
  //    { path: 'toastmessages', component: ToastmessagesComponent },
  //    { path: 'table', component: TableComponent },
  //    { path: 'datepicker', component: DatepickerComponent },
  //    { path: 'toogle-button', component: ToogleButtonComponent },
  //    { path: 'card-shadow', component: CardShadowComponent },
  //    { path: 'modal', component: ModalComponent },
  //    { path: 'tooltip', component: TooltipComponent },
  //    { path: 'timeline', component: TimelineComponent },
  //    { path: 'fileinput', component: FileinputComponent },
  //    { path: 'sidebar', component: SidebarComponent },
  //    { path: 'spinner', component: SpinnerComponent }
  //  ]
  //},
  {
    path: '',
    component: ShellComponent, resolve: {
      userDetails: SecurityService
    },
    children: [
      { path: '', redirectTo: 'workflowSearch', pathMatch: 'full' },
      { path: 'submited', component: SubmissionLandingPageComponent, canActivate: [WorkfGuard] },
      { path: 'instancebrowser', component: InstanceBrowserComponent, canActivate: [WorkfGuard] },
      { path: 'instancebrowser/:instanceId', component: InstanceBrowserComponent, canActivate: [WorkfGuard] },
      { path: 'validatepgponline', component: ValidatePGPOnlineComponent },

      { path: 'workflow-search', component: WorkflowSearchComponent, canActivate: [WorkfGuard] },
      { path: 'workflowSearch', component: WorkflowSearchComponent, canActivate: [WorkfGuard] },
      { path: 'workflow-search/:subscriber/:manifest', component: ConfirmSubmissionComponent, canActivate: [WorkfGuard] },
      { path: 'workflowSearch/:subscriber/:manifest', component: ConfirmSubmissionComponent, canActivate: [WorkfGuard] },
      { path: 'workflowsearch/:subscriber/:manifest', component: ConfirmSubmissionComponent, canActivate: [WorkfGuard] },
      { path: 'manifest/:accept/:subscriber/:manifest', component: SubmissionLandingPageComponent, canActivate: [WorkfGuard] },
      { path: 'workflow-create/:code/:instanceId/:subscriberNumber', component: WorkflowInstanceCreatorComponent, canActivate: [WorkfGuard] },
      { path: 'workflow-create/:code/:instanceId/:subscriberNumber/submited-manifest', component: ExSubsConfirmSubmissionComponent, canActivate: [WorkfGuard] },
      { path: 'workflow-create/:code/:instanceId/:subscriberNumber/:currentStep', component: WorkflowInstanceCreatorComponent, canActivate: [WorkfGuard] },
      { path: 'workflow-create/:code', component: WorkflowInstanceCreatorComponent, canActivate: [WorkfGuard] },
      {
        path: 'workflow/:workflowInstanceId',
        component: WorkflowComponent, children: [
          { path: 'step/:currentStepCode', component: StepComponent, resolve: { subscriber: SubscriberInformationResolver }, canActivate: [WorkfGuard] }
        ]
      },
      {
        path: 'workflow/:workflowInstanceId/:workflowCode',
        component: WorkflowComponentNew, children: [
          { path: 'step/:currentStepCode', component: StepComponentNew, resolve: { subscriber: SubscriberInformationResolver } }
        ]
      },
      { path: 'workflow-create-pm/:code', component: WorkflowInstanceCreatorComponentPM },
      { path: 'workflow-create-pm/:code/:workflowInstanceId/:stepPreStage', component: WorkflowInstanceCreatorComponentPM },

    ]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(addGlobalResolver(routes, CommonDataResolver, 'CommmonData'), { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
